// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c9522567","71":"33c27480","98":"55a25271","237":"c411c097","245":"7791751f","293":"bc414894","307":"029b4ec8","418":"130a7361","573":"85e8a672","679":"a50587d2","691":"9dc668d6","858":"c714b5df","887":"7b7e40c0","895":"2bf9af4b"}[chunkId] + ".chunk.js";
};